export default "__VITE_ASSET__DrOnqlMQ__"